/**
 * Sidebar section identifiers used by the navigation registry.
 * Each registered nav item belongs to exactly one section.
 */
export const NAV_SECTIONS = Object.freeze({
    OVERVIEW: 'overview',
    TEAM_MANAGEMENT: 'teamManagement',
    INTERNAL_TOOLS: 'internalTools',
    SETTINGS: 'settings',
});

/**
 * Who can see a nav item in the sidebar (in addition to role + agency-type checks).
 * Route access is controlled separately via `allowedRoles` on each registry entry.
 */
export const NAV_AUDIENCE = Object.freeze({
    ALL: 'all',
    ADMIN: 'admin',
    LYT_INTERNAL: 'lytInternal',
});
